import { Component, Input } from '@angular/core';
import { AlertType, ALERT_TYPE } from './alert.model';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-alert',
  template: `
    <div class="alert-container {{ type }}">
      @if (type !== alertWithoutIcon) {
      <div class="alert-icon">
        <mat-icon>{{ type }}</mat-icon>
      </div>
      }
      <div class="alert-content"><ng-content></ng-content></div>
    </div>
  `,
  styleUrls: ['alert.component.scss'],
  imports: [MatIcon],
})
export class AlertComponent {
  @Input() type: AlertType;

  alertWithoutIcon: AlertType = ALERT_TYPE.alarm;
}
